export default __webpack_public_path__ + "static/media/bg-portal.ed0c0911.jpg";